import { Controller } from "@hotwired/stimulus"

// An action item opened from an email's link (Phelipe 2026-09-29). On the
// public page it tells ConsLog the item opened in a browser - the chat's
// "Clicked to View" (link-checking scanners don't run this). Either way it
// takes email_ref back out of the address bar, so a reload isn't a new click.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.urlValue) {
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(this.urlValue)
        else fetch(this.urlValue, { method: "POST", keepalive: true })
      } catch (_e) { /* the view simply isn't counted */ }
    }
    try {
      const url = new URL(window.location.href)
      if (!url.searchParams.has("email_ref")) return
      url.searchParams.delete("email_ref")
      window.history.replaceState(window.history.state, "", url.toString())
    } catch (_e) { /* leave the address as it is */ }
  }
}
